/**
 * AI Management Domain Menu Provider
 * Sidebar navigation for AI Management module
 */

import {
  IconDashboard,
  IconBrain,
  IconListDetails,
  IconUpload,
  IconMessageCircle,
  IconSettings,
  IconDatabase,
  IconChartBar,
  IconSparkles,
} from '@tabler/icons-react';
import { DomainMenuProvider, MenuSection } from '../../layouts/menu/types';
import { createVisibilityCheck } from './BaseMenuProvider';

class AiMenuProvider implements DomainMenuProvider {
  domainId = 'ai';

  getMenuConfig() {
    const sections: MenuSection[] = [
      // AI Features
      {
        id: 'ai-features',
        label: 'AI Features',
        items: [
          {
            id: 'ai-dashboard',
            label: 'Dashboard',
            path: '/app/ai',
            icon: <IconDashboard size={16} />,
            visible: createVisibilityCheck({ roles: ['LLM Admin', 'Admin'] }),
          },
          {
            id: 'ai-workflow',
            label: 'Workflows',
            path: '/app/ai/workflow',
            icon: <IconBrain size={16} />,
            visible: createVisibilityCheck({ roles: ['LLM Admin', 'Admin'] }),
          },
          {
            id: 'ai-sessions',
            label: 'Sessions',
            path: '/app/ai/sessions',
            icon: <IconListDetails size={16} />,
            visible: createVisibilityCheck({ roles: ['LLM Admin', 'Admin'] }),
          },
        ],
      },

      // Documents & Q&A
      {
        id: 'ai-documents',
        label: 'Documents',
        items: [
          {
            id: 'ai-document-library',
            label: 'Document Library',
            path: '/app/ai/documents',
            icon: <IconUpload size={16} />,
            visible: createVisibilityCheck({ roles: ['LLM Admin', 'Admin'] }),
          },
          {
            id: 'ai-document-qa',
            label: 'Document Q&A',
            path: '/app/ai/documents/qa',
            icon: <IconMessageCircle size={16} />,
            visible: createVisibilityCheck({ roles: ['LLM Admin', 'Admin'] }),
          },
        ],
      },

      // Administration
      {
        id: 'ai-admin',
        label: 'Administration',
        items: [
          {
            id: 'ai-feature-flags',
            label: 'Feature Flags',
            path: '/admin/ai/feature-flags',
            icon: <IconSettings size={16} />,
            visible: createVisibilityCheck({ roles: ['LLM Admin', 'Admin'] }),
          },
          {
            id: 'ai-presets',
            label: 'Workflow Presets',
            path: '/admin/ai/presets',
            icon: <IconDatabase size={16} />,
            visible: createVisibilityCheck({ roles: ['LLM Admin', 'Admin'] }),
          },
          {
            id: 'ai-usage',
            label: 'Usage & Logs',
            path: '/admin/ai/usage',
            icon: <IconChartBar size={16} />,
            visible: createVisibilityCheck({ roles: ['LLM Admin', 'Admin'] }),
          },
        ],
      },
    ];

    return {
      domainId: this.domainId,
      sections,
      metadata: {
        version: '1.0.0',
        description: 'AI Management menu',
        lastUpdated: Date.now(),
      },
    };
  }
}

export const aiMenuProvider = new AiMenuProvider();
